import jsPDF from "jspdf";
function drawTextBoxRTL(pdf, text, xRight, yStart, boxWidth, options = {}) {
    const {
        lineHeight = 6,
        drawColor = 180,
        fillColor = 240,
        textColor = 0,
        padding = 2,
        fontSize = 10,
    } = options;

    const reversedText = reverseText(text);
    pdf.setFontSize(fontSize);

    const splitText = pdf.splitTextToSize(reversedText, boxWidth - padding * 2);
    const boxHeight = splitText.length * lineHeight + padding * 2;

    // ציור רקע
    pdf.setDrawColor(drawColor);
    pdf.setFillColor(fillColor);
    pdf.rect(xRight - boxWidth, yStart, boxWidth, boxHeight, 'FD');

    // ציור טקסט
    pdf.setTextColor(textColor);
    const textY = yStart + lineHeight; // מתחילים קצת מתחת לקצה העליון
    pdf.text(splitText, xRight - padding, textY, {
        align: 'right',
        maxWidth: boxWidth - padding * 2,
    });

    // מחזיר את Y החדש אחרי הטקסט
    return yStart + boxHeight + 5;
}

export const generatePDF1 = (questionnaireDetails) => {
    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

    // שימוש בגופן העברית
    pdf.setFont("Heebo");
    pdf.setFontSize(16);
    let y = 20;
    const margin = 170;

    // שלב 1 – כותרת
    pdf.text(reverseText("טופס הסכמה למחקר"), 105, y, { align: "center" });
    y += 15;

    pdf.setFontSize(12);
    pdf.text(reverseText("שאלון רפואי - מידע מהורה"), 105, y, { align: "center" });
    y += 10;

    pdf.setFontSize(12);
    pdf.text(reverseText("1. באיזה גיל הילד?"), 190, y, { align: "right" });
    pdf.setDrawColor(180);
    pdf.setFillColor(240);
    pdf.rect(140, y - 7, 15, 10, 'FD'); // רקע לשדה הטקסט
    pdf.setTextColor(0);

    pdf.text((`${questionnaireDetails?.q1}`), 152, y, { align: 'right' })
    y += 10;
    // שלב 2 – שאלות
    pdf.setFontSize(12);
    // pdf.setFont('bold');
    pdf.text(reverseText("2. כמה פעמים, מאלו הזכורות לך, ילדך נכווה?"), 190, y, { align: "right" });
    y += 10;

    const selectedQ2 = questionnaireDetails.q2;
    const startX = 80;

    const gap = 12;

    for (let i = 1; i <= 10; i++) {
        const x = startX + (i - 1) * gap;

        // ציור עיגול
        pdf.circle(x, y, 4, 'S'); // עיגול ריק

        // מילוי אם נבחר
        if (i === selectedQ2) {
            pdf.setFillColor(50, 100, 160); // צבע מילוי (לכחול)
            pdf.setTextColor(255, 255, 255); // מספר בלבן
            pdf.circle(x, y, 4, 'F'); // עיגול מלא

        } else {
            pdf.setTextColor(0, 0, 0); // מספר בשחור
        }
        // מספר
        pdf.text(`${i}`, x, y + 1.5, { align: 'center' });
    }
    const lineSpacing = 10;
    const circleRadius = 3;
    y += 20;
    pdf.text(reverseText("3. האם ילדך סבל או סובל כעת ממחלות עור?"), 190, y, { align: "right" });
    y += 10;
    const q3Options = ["כן", "לא", "לא ידוע לי"];
    const selectedQ3 = questionnaireDetails.q3; // מספר או מחרוזת
    // const selectedQ3 = 2; // מספר או מחרוזת
    const yStart = y;
    const x = 180;

    q3Options.forEach((option, index) => {
        const y = yStart + index * 10;

        pdf.circle(x, y, 3, 'S'); // עיגול ריק
        if (index === selectedQ3 || option === selectedQ3) {
            pdf.circle(x, y, 2, 'F'); // עיגול מלא
        }

        pdf.text(reverseText(option), 174, y + 1.5, { align: 'right' });
    });
    y += 30;
    pdf.text(reverseText("במידה וכן, באיזה גיל אובחן?"), 185, y, { align: "right" });
    pdf.setDrawColor(180);
    pdf.setFillColor(240);
    pdf.rect(120, y - 7, 15, 10, 'FD'); // רקע לשדה הטקסט
    pdf.setTextColor(0);
    // pdf.text((`100`), 132, y, { align: 'right' })
    pdf.text((`${questionnaireDetails?.q3Age || ""}`), 132, y, { align: 'right' })
    y += 10;
    pdf.text(reverseText("4. האם לילד אבחנות קודמות הקשורות למחלת עור?"), 190, y, { align: "right" });
    y += 10;
    const q4Value = questionnaireDetails.q4;
    // מיקום התחלתי

    //  y += 10;
    ["כן", "לא"].forEach((option, i) => {
        const isSelected = option === q4Value;

        // ציור עיגול בחירה
        pdf.circle(180, y - 3, circleRadius, 'S'); // עיגול ריק
        if (isSelected) {
            pdf.circle(180, y - 3, circleRadius - 1, 'F'); // מלא
        }

        // טקסט של האפשרות
        pdf.text(reverseText(option), 174, y - 2, { align: 'right' });
        y += lineSpacing;
    });

    y += 5;
    pdf.text(reverseText("סמן האבחנה הרלוונטית"), 185, y, { align: "right" });
    y += 5;

    const diagnoses = [
        "אמפטיגו",
        "מחלת Stevens-Johnson",
        " שלבקת חוגרת",
        "תסמונת העור הצרוב של סטפילוקוק (SSSS)",
        "bullous pemphigoid",
        "אטופיק דרמטיטיס",
        "אחר"
    ];

    const selectedDiagnoses = questionnaireDetails.q4Diagnosis || [];
    let checkboxYStart = y;

    diagnoses.forEach((text, i) => {
        const y = checkboxYStart + i * 8;
        pdf.rect(x - 4, y, 4, 4); // ריבוע
        if (selectedDiagnoses.includes(text)) {
            pdf.line(x - 4, y, x, y + 4);
            pdf.line(x, y, x - 4, y + 4);
        }
        if (text == "Stevens-Johnson" || text == "bullous pemphigoid") {
            pdf.text(reverseText1(text), x - 10, y + 3, { align: 'right' });

        }
        else {
            pdf.text(reverseText(text), x - 10, y + 3, { align: 'right' });
        }
    });

    pdf.addPage();

    y = 20;
    // margin = 170;
    pdf.setFont('Heebo');
    pdf.setFontSize(12);
    pdf.text(reverseText("5. באיזה אופן הגעתם לבית החולים לקבל טיפול?"), 190, y, { align: "right" });
    y += 10;
    const options = [
        "רכב פרטי בבעלותנו",
        "אמבולנס",
        "תחבורה ציבורית",
        "אחר"
    ];
    const selectedOptionIndex = questionnaireDetails?.q5; // לדוגמה – "אחר"
    const otherText = questionnaireDetails?.q5Other;






    // שרטוט אפשרויות
    options.forEach((option, i) => {
        const isSelected = option === selectedOptionIndex;

        // ציור עיגול בחירה
        pdf.circle(180, y - 3, circleRadius, 'S'); // עיגול ריק
        if (isSelected) {
            pdf.circle(180, y - 3, circleRadius - 1, 'F'); // מלא
        }

        // טקסט של האפשרות
        pdf.text(reverseText(option), 174, y - 2, { align: 'right' });
        y += lineSpacing;
    });

    // אם נבחר "אחר", מציגים את הטקסט החופשי
    if (selectedOptionIndex === "אחר" && otherText) {
        pdf.setDrawColor(180);
        pdf.setFillColor(240);
        pdf.rect(90, y - 7, 90, 10, 'FD'); // רקע לשדה הטקסט
        pdf.setTextColor(0);
        pdf.text(reverseText(otherText), 170, y, { align: 'right' });
    }
    y += 10;
    pdf.text(reverseText("6. היכן נגרמה הכוויה?"), 190, y, { align: "right" });
    // pdf.text(reverseText("6. אנא תאר קצרה כיצד נכווה הילד בכוויה בגללה הגעתם לבית החולים?"), 190, y, { align: "right" });
    y += 10;
   const q6options = ["בבית", "בשטח ציבורי", "ברכב", "במסגרת חינוכית"]

    const selectedOptionIndexq6 = questionnaireDetails?.q6; // לדוגמה – "אחר"
    // const otherTextq6 = questionnaireDetails?.q6Other;






    // שרטוט אפשרויות
    q6options.forEach((option, i) => {
        const isSelected = option === selectedOptionIndexq6;

        // ציור עיגול בחירה
        pdf.circle(180, y - 3, circleRadius, 'S'); // עיגול ריק
        if (isSelected) {
            pdf.circle(180, y - 3, circleRadius - 1, 'F'); // מלא
        }

        // טקסט של האפשרות
        pdf.text(reverseText(option), 174, y - 2, { align: 'right' });
        y += lineSpacing;
    });

    // y += 10;
    // pdf.setDrawColor(180);
    // pdf.setFillColor(240);
    // pdf.rect(90, y, 90, 90, 'FD'); // רקע לשדה הטקסט
    // pdf.setTextColor(0);
    // y += 10;
    // pdf.text(reverseText(`פירוט על כיצד הילד נכווה
    //     האירוע קרה
    //     ילד בן 9`), 170, y, { align: 'right' })


    y += 10;
    pdf.text(reverseText("7. גורם לכוויה?"), 190, y, { align: "right" });
     y += 10;
 const q7options = ["חפץ חם", "חפץ חשמלי", "מים", "חשיפה לאש","אחר"]
    const selectedOptionIndexq7 = questionnaireDetails?.q7; // לדוגמה – "אחר"
    const otherTextq7 = questionnaireDetails?.q7Other;






    // שרטוט אפשרויות
    q7options.forEach((option, i) => {
        const isSelected = option === selectedOptionIndexq7;

        // ציור עיגול בחירה
        pdf.circle(180, y - 3, circleRadius, 'S'); // עיגול ריק
        if (isSelected) {
            pdf.circle(180, y - 3, circleRadius - 1, 'F'); // מלא
        }

        // טקסט של האפשרות
        pdf.text(reverseText(option), 174, y - 2, { align: 'right' });
        y += lineSpacing;
    });

    // אם נבחר "אחר", מציגים את הטקסט החופשי
    if (selectedOptionIndexq7 === "אחר" && otherTextq7) {
        pdf.setDrawColor(180);
        pdf.setFillColor(240);
        pdf.rect(90, y - 7, 90, 10, 'FD'); // רקע לשדה הטקסט
        pdf.setTextColor(0);
        pdf.text(reverseText(otherTextq7), 170, y, { align: 'right' });
    }

 y += 10;
    pdf.text(reverseText("8. מתי התרחשה החבלה?"), 190, y, { align: "right" });
    // pdf.text(reverseText("6. אנא תאר קצרה כיצד נכווה הילד בכוויה בגללה הגעתם לבית החולים?"), 190, y, { align: "right" });
    y += 10;
   const q8options = ["היום", "שעה קלה לפני ההגעה לבית החולים", "לפני מספר ימים", "לפני מעל חודש (סיבוך בכוויה)"]

    const selectedOptionIndexq8 = questionnaireDetails?.q8; // לדוגמה – "אחר"







    // שרטוט אפשרויות
    q8options.forEach((option, i) => {
        const isSelected = option === selectedOptionIndexq8;

        // ציור עיגול בחירה
        pdf.circle(180, y - 3, circleRadius, 'S'); // עיגול ריק
        if (isSelected) {
            pdf.circle(180, y - 3, circleRadius - 1, 'F'); // מלא
        }

        // טקסט של האפשרות
        pdf.text(reverseText(option), 174, y - 2, { align: 'right' });
        y += lineSpacing;
    });
    // שלב 3 – סיום
    
    pdf.addPage();

    y = 20;
    pdf.text(reverseText("9. אנא תאר קצרה כיצד נכווה הילד בכוויה בגללה הגעתם לבית החולים?"), 190, y, { align: "right" });
    y += 10;
     y = drawTextBoxRTL(
        pdf,
        questionnaireDetails?.q9,
        // `הילד הגיע לטיפול דרך תחבורה ציבורית\nהילד הגיע לטיפול דרך תחבורה ציבור\nהילד הגיע לטיפול דרך תחבורה ציבורית\nהילד הגיע לטיפול דרך תחבורה ציבורית `,
        180,  // xRight – הקצה הימני
        y,    // yStart
        90    // boxWidth
    );
    y += 20;
    pdf.setFontSize(12);
    pdf.text(reverseText("תודה על השתתפותך!"), margin, y, { align: "right" });

    // שמירה
    // pdf.save("questionnaire.pdf");
    return pdf
};





const reverseText = (text) =>
    text
        .split('\n')
        .map((line) => line.split('').reverse().join(''))
        .join('\n');


function reverseText1(line) {
  const words = line.split(' ');
  const reversedWords = words.map(word => {
    return /[\u0590-\u05FF]/.test(word) // אם המילה בעברית
      ? word.split('').reverse().join('')
      : word;
  });
  return reversedWords.reverse().join(' ');

}

function applyBidiFix(text) {
  const isHebrew = /[\u0590-\u05FF]/.test(text);
  if (isHebrew) {
    return `\u202B${text}\u202C`; // RTL
  } else {
    return `\u202A${text}\u202C`; // LTR
  }
}